<template>
  <div class="cell-actions" @click.stop>
    <ActionButton
      v-for="action in actions"
      :key="action.title"
      v-b-tooltip.hover="{
        title: action.title,
        container: 'body',
        customClass: 'cell-renderer-actions-tooltip',
      }"
      :link="action.link"
      :title="action.title"
      tooltip
      :icon="action.icon"
      @click="action.onClick && action.onClick(params.data)"
    />
  </div>
</template>

<script>
import ActionButton from '@/components/common/action-button.vue';

// Allgemeiner Cell-Renderer für Icon-Aktionen mit Tooltip
// Erwartet cellRendererParams.actions: params => [{ icon, title, link?, onClick? }]
export default {
  components: { ActionButton },
  computed: {
    actions() {
      return this.params.actions(this.params);
    },
  },
};
</script>

<style>
.cell-renderer-actions-tooltip .tooltip-inner {
  max-width: none;
  white-space: nowrap;
}
</style>
